import React, { useEffect, useRef, useState }   from 'react';
import { Modal, Form, Button }                  from 'react-bootstrap';
import { Formik }                               from 'formik';
import * as yup                                 from 'yup';

import clienteAxios                             from '../../../../../config/axios';

import { ErrorMessage, SuccessMessage }         from '../../../../extras/toastMessages';
import { ICON_SAVE, ICON_CANCEL }               from '../../../../extras/icons';
import { IMPUTADO_GROUP }                       from '../../../../../data/resultTypeGroups';
import { MSG_ERROR_SERVER }                     from '../../../../../constants/messages';
import { MSG_SAVE_ACCUSED_RESULT_SUCCESS }      from '../../../../../constants/messages';



const AccusedResultForm = props => {


    // --------------------------------------------------------------------------------------------
    // DEFINICIONES -------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    // Tomo los props
    const { accused, audience, handleClose, setAccused, show, tipos } = props;

    // Genero los ref
    const refResult = useRef();

    // Inicializo datos
    const initialData = {
        observacion: '',
        modalidad: '',
        plazo: '',
        tipo: '',
    }

    // Inicializo el state local
    const [data, setData] = useState(initialData);
    const [modalities, setModalities] = useState([]);
    const [resultTypes, setResultTypes] = useState([]);


    // --------------------------------------------------------------------------------------------
    // FUNCIONES ----------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    // Manejo cuando se muestra
    const handleOnShow = e => {
        //Cargo los motivos
        if(!resultTypes || resultTypes.length===0)
            loadResults();
        //Pongo el foco en el primer campo
        refResult.current.focus();
    }

    // Manejo el guardado
    const handleSave = async values => {
        try
        {   //Armo los datos
            const data = {
                imputadoId: accused.id,
                modalidadId: values.modalidad,
                observaciones: values.observacion,
                plazo: values.plazo,
                resultadoId: values.tipo,
            }
            //Hago la Llamada
            const response = await clienteAxios.post(`/audiencia/imputado-resultado`, data);
            setAccused(response.data);
            SuccessMessage(MSG_SAVE_ACCUSED_RESULT_SUCCESS);
            handleClose();
        }
        catch(error)
        {   const response = error.response;
            let data = MSG_ERROR_SERVER;
            if(response) data = response.data;
            ErrorMessage(data);
        }
    }

    // Función que cargar los motivos
    const loadResults = async () => {
        try
        {   //Hago la consulta que va dentro de TRATAMIENTO
            const response = await clienteAxios.get(`/resultado/dto?search=tipo:${IMPUTADO_GROUP},activo:1&sort=descripcion:asc`);
            //Obtengo los datos
            const resultTypes = response.data;
            //Inicializo los resultados posibles
            let enabledResults = [];
            //Busco los resultados posibles
            audience.audienciaTipoList.forEach(type => {
                type.resultadoList.forEach(result => {
                    enabledResults = [
                        ...enabledResults,
                        result
                    ]
                })
            })
            //Filtro los resultados posibles
            const resultTypeOk = resultTypes.content.filter(resultType => enabledResults.find(r => r.id === resultType.id));
            //Llamo al dispatch
            setResultTypes(resultTypeOk);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response)
            {   data = response.data;
            }
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
    const loadResultsReconvertida = async () => {
        try
        {   const resp = await clienteAxios.post('/resultado/imputado', { tipos } ); 
            setResultTypes(resp.data);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response)
            {   data = response.data;
            }
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }

    //Esquema de validación
    const validationSchema = yup.object({
        modalidad: yup.number().nullable(),
        observacion: yup.string().nullable(),
        plazo: yup.number().nullable(),
        tipo: yup.number().required()
    });

    useEffect(() => {
        if(tipos?.length>0)
        {   loadResultsReconvertida();
        }
        // eslint-disable-next-line
    }, [tipos])  

    useEffect(() => {
        if(accused.resultado)
        {   let tipo = '';
            if(resultTypes)
            {   tipo = resultTypes.filter(el=>el.descripcion===accused.resultado?.descripcion)[0]?.id;
            }
            setData({
                observacion: accused?.resultadoObs || '',
                modalidad:  accused?.modalidad?.id || '',
                plazo: accused?.plazo || '',
                tipo: tipo,
            });
        }
        // eslint-disable-next-line
    }, [accused, resultTypes])    


    // --------------------------------------------------------------------------------------------
    // RENDERIZO ----------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------------------

    return (
        <Modal
            aria-labelledby = "contained-modal-title-vcenter" 
            centered
            onHide = { handleClose }  
            onShow = { handleOnShow } 
            show = { show } 
            size = "lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Resultado Imputado: <strong>{ accused.persona.apellido + ', ' + accused.persona.nombre}</strong> 
                    <br/>
                    <small>(Audiencia #{ audience.id })</small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                initialValues = {{ ...data }}
                onSubmit = { values=>handleSave(values) }
                validationSchema = { validationSchema }
            >
                {   function MyForm({
                        handleSubmit,
                        values,
                        errors
                    }) {

                    // Manejo de Cambios
                    const handleChange = e => {
                        if(e.target.name==='tipo')
                        {   // Limpia las modalidades cuando cambio el resultado
                            setData({
                                ...data,
                                modalidad: '',                                
                                tipo: e.target.value
                            });
                        }
                        else
                        {   setData({
                                ...data,
                                [e.target.name]: e.target.value
                            });  
                        }
                    }

                    // Actualizar las Modalidades cada vez que se cambia el Resultado
                    useEffect(() => {
                        const auxModalities = resultTypes.filter(el=>el.id===Number(values.tipo))[0]?.modalidades;
                        setModalities(auxModalities);
                        // eslint-disable-next-line
                    }, [values])                    
                    
                    // Renderizo el Form
                    return (
                        <form noValidate onSubmit={handleSubmit} autoComplete="off">
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="alert alert-info">
                                            Complete los siguientes campos para cargar el resultado
                                        </div>
                                    </div>
                                    <Form.Group className="col-md-12">
                                        <label htmlFor="tipo">Resultado</label>
                                        <Form.Control
                                            as = "select"
                                            className = "form-control"
                                            id = "tipo"  
                                            isInvalid = { !!errors.tipo }
                                            name = "tipo" 
                                            onChange = { handleChange }
                                            ref = { refResult }
                                            value = { values.tipo }
                                        >
                                            <option value="">Selecione...</option>
                                            {   resultTypes.map( resultType=>(
                                                    <option value={ resultType.id} key={`rfr${ resultType.id }`}>
                                                        { resultType.descripcion }
                                                    </option>
                                                ))
                                            }
                                        </Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                            { errors.tipo }
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="col-md-12">
                                        <label htmlFor="observacion">Observaciones</label>
                                        <Form.Control
                                            className = "form-control" 
                                            id = "observacion"
                                            isInvalid = { !!errors.observacion }
                                            name = "observacion" 
                                            onChange = { handleChange }
                                            placeholder = "Ingrese observación"
                                            type = "text" 
                                            value = { values.observacion }
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            { errors.observacion }
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="col-md-3">
                                        <label htmlFor="plazo">Plazo</label>
                                        <Form.Control
                                            className = "form-control" 
                                            id = "plazo"
                                            isInvalid = { !!errors.plazo }
                                            name = "plazo" 
                                            onChange = { handleChange }
                                            placeholder = "Ingrese plazo"
                                            type = "text" 
                                            value = { values.plazo }
                                        />
                                        <small id="passwordHelpBlock" className="form-text text-muted">
                                            Cantidad en días
                                        </small>
                                        <Form.Control.Feedback type="invalid">
                                            { errors.plazo }
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="col-md-9">
                                        <label htmlFor="modalidad">Modalidad</label>
                                        <Form.Control
                                            as = "select"
                                            className = "form-control"
                                            id = "modalidad"
                                            isInvalid = { !!errors.modalidad }
                                            key = { values.tipo }
                                            name = "modalidad" 
                                            onChange = { handleChange }
                                            value = { values.modalidad }
                                        >
                                            <option value="">Selecione...</option>
                                            {   modalities?.map( modality=>(
                                                    <option value={ modality.id} key={`rfm${ modality.id }`}>
                                                        { modality.descripcion }
                                                    </option>
                                                ))
                                            }
                                        </Form.Control>
                                        <Form.Control.Feedback type="invalid">
                                           { errors.modalidad }
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="success" type="submit">
                                    <ICON_SAVE /> <strong>GUARDAR RESULTADO</strong>
                                </Button>
                                <Button variant="secondary" onClick={handleClose}>
                                    <ICON_CANCEL /> Cancelar
                                </Button>
                            </Modal.Footer>
                        </form>
                ) } }
            </Formik>
        </Modal>
    );
};

export default AccusedResultForm;